import config from './config'

export default {
  modules: {
    config
  }
}
